module.exports = __webpack_public_path__ + "static/media/10_l_stena_0_0.7f387c9d.png";